export default "/images/vendor/flag-icon-css/flags/4x3/cz.svg?8ef2bc6a4d5bad23e2843b0f7142f0c7";